module.exports = __webpack_public_path__ + "static/media/sad.242587bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/smileys/sad.svg
// module id = 278
// module chunks = 0